/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles, fade } from '@material-ui/core/styles';
import { useSelector } from 'react-redux'
import axios from 'axios';
import { API_URL } from '../../constants';
import { useRecoilState } from 'recoil';
import { DossierIdState } from '../../app/recoil/State'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderRadius: '24px',
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

export default function ComboBox() {
    const classes = useStyles();
    // call recoil and change dossierid
    const [dossierIdState,setDossierIdState] = useRecoilState(DossierIdState)

    const auth = useSelector(state => state.auth);
    const userID = auth.userId
    const [dossierList, setDossierList] = useState('')
    const [user, setUser] = useState('')


    // axios dossiers by users
    useEffect(() => {
        axios.get(`${API_URL}/collections/byuser/${userID}`).
            then(res => {
                setDossierList(res.data)
            })
    }, [])

    // select user
    useEffect(() => {
        axios.get(`${API_URL}/users/${userID}`).then(
            res => {
                setUser(res.data)
            }
        )
    }, [])

// build custimized list {id,dossierId,name}
    const filteredList = dossierList.dossiers!==undefined && user.user!== undefined ? dossierList.dossiers.map((el, index) => {
        return {
            dossierId: user.user.fullname + index,
            name: el.name,
            id: el._id
        }
    }) : null
    
    return (
        <Autocomplete
            id="combo-box-demo"
            options={filteredList}
            getOptionLabel={(option) => option.dossierId}
            style={{ width: 300 }}
            onChange={(event, value) => setDossierIdState(value.id) }
            renderInput={(params) => {
                return (

                    <div className={classes.search}>
                        <div className={classes.searchIcon}>
                            <SearchIcon />
                        </div>
                        <TextField
                            {...params}
                            placeholder="Search…"
                            classes={{
                                root: classes.inputRoot,
                                input: classes.inputInput,
                            }}
                            variant="outlined"

                        />

                    </div>

                )
            }}
        />
    );
}

